import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { CalendarIcon } from 'lucide-react';
import { format } from 'date-fns';
import type { DateRange } from '@/types/client';

export interface FilterState {
  dateRange: DateRange;
  marketplace: string;
  brand: string;
  category: string;
  sku: string;
}

interface GlobalFiltersProps {
  filters: FilterState;
  onFiltersChange: (filters: FilterState) => void;
}

export function GlobalFilters({ filters, onFiltersChange }: GlobalFiltersProps) {
  const [dateOpen, setDateOpen] = useState(false);

  return (
    <div className="flex items-center space-x-4 p-4 bg-[#11171C] rounded-lg border border-[#FF8A00]/20">
      <Popover open={dateOpen} onOpenChange={setDateOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" className="text-[#E6EAED] border-[#FF8A00]/20">
            <CalendarIcon className="mr-2 h-4 w-4" />
            {filters.dateRange.from ? (
              filters.dateRange.to ? (
                <>
                  {format(filters.dateRange.from, "LLL dd, y")} -{" "}
                  {format(filters.dateRange.to, "LLL dd, y")}
                </>
              ) : (
                format(filters.dateRange.from, "LLL dd, y")
              )
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-[#11171C] border-[#FF8A00]/20" align="start">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={filters.dateRange.from}
            selected={filters.dateRange}
            onSelect={(range) => {
              if (range) {
                onFiltersChange({
                  ...filters,
                  dateRange: range as DateRange
                });
              }
            }}
            numberOfMonths={2}
            className="p-3 pointer-events-auto"
          />
        </PopoverContent>
      </Popover>

      <Select value={filters.marketplace} onValueChange={(value) => onFiltersChange({ ...filters, marketplace: value })}>
        <SelectTrigger className="w-32 text-[#E6EAED] border-[#FF8A00]/20">
          <SelectValue placeholder="Marketplace" />
        </SelectTrigger>
        <SelectContent className="bg-[#11171C] border-[#FF8A00]/20">
          <SelectItem value="all">Tous</SelectItem>
          <SelectItem value="FR">France</SelectItem>
          <SelectItem value="DE">Allemagne</SelectItem>
          <SelectItem value="IT">Italie</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}